import { Component, ElementRef, HostListener, inject } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-bottom-bar',
  imports: [NgClass],
  templateUrl: './bottom-bar.component.html',
  styleUrl: './bottom-bar.component.scss',
})
export class BottomBarComponent {
  private el = inject(ElementRef);
  public sticky: boolean = true;

  @HostListener('window:scroll', ['$event']) onScroll(): void {
    this.checkIfSticky();
  }

  @HostListener('window:resize', ['$event']) onResize(): void {
    this.checkIfSticky();
  }

  checkIfSticky(): void {
    if (!this.el || !this.el.nativeElement) return;
    const el = this.el.nativeElement;
    const bottomBarEl = el.querySelector('.bottom-bar');
    if (!bottomBarEl) return;
    const bottomBarHeight = bottomBarEl.getBoundingClientRect().height;
    const bottomBarOffset = bottomBarEl.getBoundingClientRect().top;
    const windowHeight = window.innerHeight;
    if (bottomBarOffset - windowHeight + bottomBarHeight <= 0) this.sticky = false;
    else this.sticky = true;
  }
}
